if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');

  const spinner = this.querySelector('.loading-overlay__spinner');
  if (spinner) spinner.classList.remove('hidden');

  // Clean up any useless hidden fields
  this.form.querySelectorAll(
    'input[name="form_type"], input[name="utf8"], input[name="product-id"], input[name="section-id"], input[name="add"]'
  ).forEach(el => el.remove());

  // Get the variant + quantity
  const variantId = this.form.querySelector('[name=id]')?.value;
  const quantity = this.form.querySelector('[name=quantity]')?.value || 1;

  // Build JSON body without properties
  const cleanBody = JSON.stringify({
  items: [{
    id: parseInt(variantId),
    quantity: parseInt(quantity)
  }],
  sections: ['cart-drawer', 'cart-notification', 'cart-icon-bubble'],
  sections_url: window.location.pathname
});


  const config = fetchConfig('javascript');
  config.headers['Content-Type'] = 'application/json';
  config.body = cleanBody;



  fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then((response) => {
  window.lastResponse = response;
  
  if (response.status) {
    this.handleErrorMessage(response.description);
    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
    if (soldOutMessage) {
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.querySelector('span').classList.add('hidden');
      soldOutMessage.classList.remove('hidden');
    }
    this.error = true;
    return;
  }
  
  if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
  this.error = false;

  // Calculate total items in cart from response
  let totalItems = 0;
  if (response.items && Array.isArray(response.items)) {
    totalItems = response.items.reduce((sum, item) => sum + item.quantity, 0);
  }

  // Update cart bubble
  const cartBubble = document.querySelector('.cart-count-bubble span');
  if (cartBubble && totalItems > 0) {
    cartBubble.textContent = totalItems;
  }

  // Update drawer and open it
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && response.sections?.['cart-drawer']) {
    const html = response.sections['cart-drawer'];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const drawerInner = doc.querySelector('.drawer__inner');
    
    if (drawerInner) {
      const currentDrawerInner = document.querySelector('.drawer__inner');
      if (currentDrawerInner) {
        currentDrawerInner.innerHTML = drawerInner.innerHTML;
      }
    }
    
    cartDrawer.open();
  }
})
    .catch((e) => console.error('❌ Add to cart failed:', e))
    .finally(() => {
      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');

      // Force the button to be visible
      this.submitButton.style.display = 'block';
      this.submitButton.style.visibility = 'visible';
      this.submitButton.style.opacity = '1';
      this.submitButton.style.pointerEvents = 'auto';

      if (this.cart && this.cart.classList.contains('is-empty'))
        this.cart.classList.remove('is-empty');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
}


    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

function publish(event, data) {
  document.dispatchEvent(new CustomEvent(event, { detail: data }));
}
